export default {
  classes: {
    container: 'relative grid grid-flow-col grid-rows mt-2 p-6 rounded bg-gray-200',
    body: 'grid 2xl:grid-cols-8 lg:grid-cols-4 grid-cols-1 gap-4 mt-4',
  },
  variants: {},
}
